import { defineComponent as _defineComponent } from 'vue'
import { useUtil } from '@/plugins/util'
import router from '@/router'
import { useAuthStore } from '@/store/pinia/auth'
import { usePhysicianStore } from '@/store/pinia/physician'
import { EventBusInjectionKey } from '@/utils/injection-keys'
import { IconSlug } from '@/v2/components/ui/icon/iconMap'
import AppMenuButton from '@/v2/components/ui/menu/AppMenuButton.vue'
import { computed, inject, onBeforeUnmount, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import AppIcon from '../../../ui/icon/AppIcon.vue'
import MenuOptionButton from './MenuOptionButton.vue'
import SelectCard, { CardSlug } from './SelectCard.vue'

export interface NavMenuItem {
  path: string
  name: string
  title: string
  icon: IconSlug
  tooltip?: string
  priority?: number
  parent?: string
}
type BottomItem = {
  text: string
  icon: IconSlug
  key: CardSlug
  bottom?: string
  show: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseMenu',
  props: {
  navMenuItems: null
},
  setup(__props) {

const props = __props;

const eventBus = inject(EventBusInjectionKey)!

const route = useRoute()
const authStore = useAuthStore()



const expandedMenu = ref(false)
const inHover = ref(false)

function handleMouseEvent(e: MouseEvent) {
  if (e.type == 'mouseleave' && e.offsetX < 277 && e.offsetY >= 0 && e.offsetY < document.body.clientHeight - 1) {
    return
  }

  if (expandedMenu.value) {
    inHover.value = false

    return
  }

  inHover.value = !inHover.value
}

function toggleMenuExpansion() {
  expandedMenu.value = !expandedMenu.value

  if (!expandedMenu.value) {
    inHover.value = true
  }
}

const menuStateCSS = computed(() => {
  if (expandedMenu.value) {
    return 'tw-w-[277px]'
  }

  if (!expandedMenu.value && !inHover.value) {
    return 'tw-w-[76px]'
  }

  return 'tw-w-[277px]  tw-transition-[width] tw-duration-[150ms] hover:tw-absolute hover:tw-z-10 hover-box-shadow '
})

const selectedMenuItem = ref<string | null>('home')
watch(
  () => route.fullPath,
  (newValue, oldValue) => {
    if (route.meta?.parent) {
      selectedMenuItem.value = route.meta.parent
    } else {
      selectedMenuItem.value = route.name ?? null
    }
  },
  { immediate: true },
)

const util = useUtil()
const physicianStore = usePhysicianStore()
function goToSelectedPath(menuItem: NavMenuItem) {
  const analytics = util.prepareSegment()
  const userData = util.prepareSegmentUserProperties(physicianStore)
  analytics.track('Clique em botão no menu', {
    button: menuItem.name,
    buttonTitle: menuItem.title,
    ...userData,
  })
  router.push({ name: menuItem.name })
}

const bottomItems = computed<BottomItem[]>(() => [
  {
    text: 'Ajuda',
    icon: 'lifebuoy',
    key: 'Ajuda',
    show: true,
  },
  // {
  //   text: authStore.pharmaceuticalDomainConfig.PROJECT_TITLE,
  //   icon: 'workspace',
  //   key: 'Seus Projetos',
  //   show: [].length > 1,
  // },
])

const selectedBottomItem = ref<BottomItem | null>(null)

function selectBottomItem(item: BottomItem, index: number) {
  const analytics = util.prepareSegment()
  const userData = util.prepareSegmentUserProperties(physicianStore)
  analytics.track('Clique em botão no menu', {
    button: item.text,
    buttonTitle: item.key,
    ...userData,
  })
  let position = (bottomItems.value.filter((bI) => bI.show).length - index - 1) * 40 + 20

  const bottom = `${position}px`
  selectedBottomItem.value = { ...item, bottom }
}

function resetSelectBottomItem() {
  selectedBottomItem.value = null
}

function closeOnHoverMenu() {
  inHover.value = false
}

eventBus.addListener('sideMenu:close', closeOnHoverMenu)
onBeforeUnmount(() => eventBus.off('sideMenu:close', closeOnHoverMenu))

return { __sfc: true,eventBus, route, authStore, props, expandedMenu, inHover, handleMouseEvent, toggleMenuExpansion, menuStateCSS, selectedMenuItem, util, physicianStore, goToSelectedPath, bottomItems, selectedBottomItem, selectBottomItem, resetSelectBottomItem, closeOnHoverMenu, AppMenuButton, AppIcon, MenuOptionButton, SelectCard }
}

})